import { render, staticRenderFns } from "./UsersList.view.vue?vue&type=template&id=636ff088&scoped=true&"
import script from "./UsersList.view.vue?vue&type=script&lang=js&"
export * from "./UsersList.view.vue?vue&type=script&lang=js&"
import style0 from "./UsersList.view.vue?vue&type=style&index=0&id=636ff088&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636ff088",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VChip,VIcon,VTooltip})
